import React from "react";
import { styled } from "@mui/material/styles";
import { Button, CircularProgress } from "@mui/material";

const StyledButton = styled(Button)(({ theme }) => ({
  width: "100%",
  fontFamily: theme.typography.fontFamily,
  background: theme.palette.primary.silver,
  color: theme.palette.colors.BlackBean,
  margin: "6px 0",
  borderRadius: "10px",
  fontStyle: "normal",
  fontWeight: 900,
  fontSize: "16px",
  lineHeight: "22px",
  textAlign: "center",
  height: "50px",
  textTransform: "capitalize",
  boxShadow: "none",
  "&:hover": { background: "#E2E2E2" },
  "& span.MuiCircularProgress-root": {
    color: "#000",
  },
}));

const OAuthButton = ({
  onClick,
  label,
  variant,
  color,
  disabled,
  type,
  isLoading = false,
  imageUrl = "",
}) => {
  return (
    <>
      <StyledButton
        onClick={onClick}
        variant={variant}
        color={color}
        disabled={disabled || isLoading}
        type={type}
      >
        {isLoading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          <>
            {imageUrl && (
              <img
                src={imageUrl}
                alt="button icon"
                style={{ marginRight: "10px" }}
              />
            )}
            {label}
          </>
        )}
      </StyledButton>
    </>
  );
};
OAuthButton.defaultProps = {
  label: "text",
  variant: "contained",
  color: "primary",
  disabled: false,
  type: "button",
};
export default OAuthButton;
